<template>
  <el-dialog
    v-el-drag-dialog
    :close-on-click-modal="false"
    title="查看物流"
    width="800px"
    top="2vh"
    center
    :visible="visible"
    @close="closeDialog()"
  >
    <!-- <el-row
      class="express-timeline"
      v-for="(item, index) in detail"
      :key="index"
      style="padding: 10px 0; line-height: 20px"
      v-if="detail.length > 0"
    >
      <el-col :span="17">{{ item.context }}</el-col>
      <el-col :span="2"><div style="height: 20px"></div></el-col>
      <el-col :span="5" style="text-align: right">{{ item.time }}</el-col>
    </el-row> -->
    <el-timeline v-if="detail.length > 0">
      <el-timeline-item
        v-for="(item, index) in detail"
        :key="index"
        :timestamp="item.time"
      >
        {{ item.context }}
      </el-timeline-item>
    </el-timeline>
    <div v-if="detail.length == 0">{{ errors }}</div>
  </el-dialog>
</template>

<script>
export default {
  name: "ExpressInfo",
  data() {
    return {
      detail: [],
      errors: "",
      express_no: "",
      delivery_no: "",
      order_no: "",
    };
  },
  props: {
    visible: Boolean,
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
    },
    initData() {
      const { express_no, delivery_no, order_no } = this;
      this.$.http
        .get("index/express/info", {
          express_no,
          delivery_no,
          order_no,
        })
        .then((res) => {
          this.detail = res.data.info || [];
        })
        .catch((res) => {
          this.errors = res.message;
        });
    },
    send({ express_no, delivery_no, order_no }) {
      this.express_no = express_no;
      this.delivery_no = delivery_no;
      this.order_no = order_no;
      this.initData();
    },
  },
};
</script>

<style scoped>
.express-timeline {
}
</style>



// WEBPACK FOOTER //
// src/components/ExpressInfo/index.vue